export default "static/src/images/banner-mondo-di-limes_mobile.png";